// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";

import { Stack, useMediaQuery, useTheme, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import {
  GridColDef,
  GridRowId,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { Table } from "../../molecules";
import { Loading, Button } from "../../atoms";
import {
  DeleteMerchantRequest,
  IMerchant,
  PagingResponse,
  useAuthorization,
  useGetMerchantUnPaidHistory,
  MerchantUnPaidHistoryResponse
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import dayjs from "dayjs";



export const PendingPaymentsList = () => {
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [showTable, setShowTable] = useState(false)
  const navigate = useNavigate();
  const { mutate: getMerchantUnPaidHistory, isLoading } = useGetMerchantUnPaidHistory();
  const setSnackbar = useSetSnackBar();
  const [shouldRefresh, setShouldRefresh] = React.useState(0);
  const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(null);
  const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const savedFilter = localStorage.getItem("pendingPaymentsTableFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "Term",
      orderByDesc: true,
      status: "",
      filters: isInitialLoad ? [] : createFilters(),
      ...getQueryParams(queryOptions),
    };

    getMerchantUnPaidHistory(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const dataWithIds = {
              ...data.data,
              result: data.data?.result?.map((item, index) => ({
                ...item,
                id: index + 1
              })) || []
            };
            setTableData(dataWithIds);
            setIsInitialLoad(false);
            if (!data?.data?.result || data?.data?.result.length === 0) {
              setSnackbar({
                severity: "info",
                description: "Belirtilen kriterlere uygun veri bulunamadı",
                isOpen: true,
              });
            }
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }, [
    getMerchantUnPaidHistory,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    isInitialLoad,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    const requestPayload = {
      size: model.pageSize,
      page: model.page,
      orderBy: "Term",
      orderByDesc: true,
      status: "",
      filters: createFilters(),
      ...getQueryParams(queryOptions),
    };

    getMerchantUnPaidHistory(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const dataWithIds = {
              ...data.data,
              result: data.data?.result?.map((item, index) => ({
                ...item,
                id: (paginationModel.page * paginationModel.pageSize) + index + 1
              })) || []
            };
            setTableData(dataWithIds);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "term",
        headerName: "Dönem",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "totalVPos", headerName: "Sanal Pos Tutarı", width: 200, type: 'decimal' },
      { field: "totalFPos", headerName: "Fiziksel Pos Tutarı", width: 200, type: 'decimal' },
      { field: "reservBalance", headerName: "Koruma Hesap Bakiyesi", width: 200, type: 'decimal' },
      {
        field: "reservBalanceLastDate",
        headerName: "Son Koruma Bakiye Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "balanceDifference", headerName: "Fark", width: 200, type: 'decimal' },
    ];
  }, []);

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "Term",
      orderByDesc: true,
      status: "",
      filters: createFilters(),
      ...getQueryParams(queryOptions),
    };

    getMerchantUnPaidHistory(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const refactoredData = data?.data?.result?.map((item) => ({
              "Dönem": dayjs(item.term).format("DD.MM.YYYY"),
              "Sanal Pos Tutarı": item.totalVPos,
              "Fiziksel Pos Tutarı": item.totalFPos,
              "Koruma Hesap Bakiyesi": item.reservBalance,
              "Son Koruma Bakiye Tarihi": dayjs(item.reservBalanceLastDate).format("DD.MM.YYYY"),
              "Fark": item.balanceDifference
            }));
            downloadExcel(refactoredData || [], "Ödenmemiş Tutarlar Listesi", null);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const createFilters = () => {
    const filters = [];

    if (startDate) {
      filters.push({
        field: "startTerm",
        values: [startDate.format("YYYY-MM-DD")],
        valueType: 4,
        operationType: 6
      });
    }

    if (endDate) {
      filters.push({
        field: "endTerm",
        values: [endDate.format("YYYY-MM-DD")],
        valueType: 4,
        operationType: 6
      });
    }

    return filters;
  };

  const handleFilterSubmit = () => {
    if (startDate && !startDate.isValid()) {
      setSnackbar({
        severity: "error",
        description: "Geçerli bir başlangıç tarihi giriniz",
        isOpen: true,
      });
      return;
    }
    if (endDate && !endDate.isValid()) {
      setSnackbar({
        severity: "error",
        description: "Geçerli bir bitiş tarihi giriniz",
        isOpen: true,
      });
      return;
    }
    setShouldRefresh(prev => prev + 1);
  };

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0 || startDate || endDate;
  const hasLoading = isLoading;

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2} >
        <BaseFilterTableWithAccordion
          summary="Filtreler"
          isExpanded={isFilterAccordionExpanded}
          setExpanded={setFilterAccordionExpand}
          setTableVisibility={setShowTable}
          child={
            <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  <DatePicker
                    label="Başlangıç Tarihi"
                    value={startDate}
                    format="DD.MM.YYYY"
                    onChange={(newValue) => setStartDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <DatePicker
                    label="Bitiş Tarihi"
                    value={endDate}
                    format="DD.MM.YYYY"
                    onChange={(newValue) => setEndDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <Button
                    onClick={handleFilterSubmit}
                    size="small"
                    variant="contained"
                    text="Listele"
                    sx={{ mb: 2, height: 40 }}
                  />
                </Stack>
              </LocalizationProvider>
            </Stack>
          }
        />

        <Table
          columnVisibilityConfigKey="pendingPaymentsTableColumnVisibilityKey"
          filterKey="pendingPaymentsTableFilter"
          hasActiveFilters={hasActiveFilters}
          paginationModel={paginationModel}
          onPaginationModelChange={handleChangePagination}
          paginationMode="server"
          rowCount={tableData?.totalItems || 0}
          sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
          rows={tableData?.result ?? []}
          columns={columns}
          exportFileName="Bekleyen Hakedişler Listesi"
          onSave={() => onSave()}
          disableColumnFilter={false}
        />
      </Stack>
    </>
  );
};
